interface MdNode {
  type: string;
  children?: MdNode[];
  value?: string;
}

interface TextNode {
  type: "text";
  value: string;
}

const EVIDENCE_MARKER = /\[@([a-z0-9]+(?:-[a-z0-9]+)*)\]/g;
const LITERAL_PARENTS = new Set([
  "code",
  "inlineCode",
  "link",
  "linkReference",
  "definition",
]);

function splitEvidenceMarkers(value: string): MdNode[] {
  const nodes: MdNode[] = [];
  let cursor = 0;
  for (const match of value.matchAll(EVIDENCE_MARKER)) {
    const index = match.index ?? 0;
    if (index > cursor) nodes.push({ type: "text", value: value.slice(cursor, index) });
    const id = match[1]!;
    nodes.push({
      type: "link",
      url: `evidence:${id}`,
      title: null,
      children: [{ type: "text", value: id } satisfies TextNode],
      data: {
        hProperties: {
          "data-evidence-reference": "true",
          "data-evidence-id": id,
        },
      },
    } as unknown as MdNode);
    cursor = index + match[0].length;
  }
  if (cursor === 0) return [{ type: "text", value }];
  if (cursor < value.length) nodes.push({ type: "text", value: value.slice(cursor) });
  return nodes;
}

function walk(node: MdNode): void {
  if (LITERAL_PARENTS.has(node.type) || !Array.isArray(node.children)) return;
  const next: MdNode[] = [];
  for (const child of node.children) {
    if (child.type === "text" && typeof child.value === "string" && child.value.includes("[@")) {
      next.push(...splitEvidenceMarkers(child.value));
    } else {
      walk(child);
      next.push(child);
    }
  }
  node.children = next;
}

/** Dependency-free render-tree transform for CodeWiki `[@evidence-id]` markers. */
export function remarkEvidenceReferences() {
  return (tree: MdNode): void => walk(tree);
}
